import * as React from 'react';
import { CONTEXT_UPDATE, FOCUS_OUTSIDE } from './constants';
import { useCallbackRef } from '../../hooks/useCallbackRef';
import { dispatchDiscreteCustomEvent } from '../../utils/dispatchDiscreteCustomEvent';

/**
 * Слушает, когда фокус происходит вне поддерева React.
 * Возвращает свойства для передачи корневому (узлу) поддерева, которое мы хотим проверить.
 */
export function useFocusOutside(onFocusOutside) {
  let ownerDocument = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : globalThis === null || globalThis === void 0 ? void 0 : globalThis.document;
  const handleFocusOutside = useCallbackRef(onFocusOutside);
  const isFocusInsideReactTreeRef = React.useRef(false);
  React.useEffect(() => {
    const handleFocus = event => {
      if (event.target && !isFocusInsideReactTreeRef.current) {
        const eventDetail = {
          originalEvent: event
        };
        handleAndDispatchCustomEvent(FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
          discrete: false
        });
      }
    };
    ownerDocument.addEventListener('focusin', handleFocus);
    return () => ownerDocument.removeEventListener('focusin', handleFocus);
  }, [ownerDocument, handleFocusOutside]);
  return {
    onFocusCapture: () => isFocusInsideReactTreeRef.current = true,
    onBlurCapture: () => isFocusInsideReactTreeRef.current = false
  };
}
export function dispatchUpdate() {
  const event = new CustomEvent(CONTEXT_UPDATE);
  document.dispatchEvent(event);
}
export function handleAndDispatchCustomEvent(name, handler, detail, _ref) {
  let {
    discrete
  } = _ref;
  const target = detail.originalEvent.target;
  const event = new CustomEvent(name, {
    bubbles: false,
    cancelable: true,
    detail
  });
  if (handler) {
    target.addEventListener(name, handler, {
      once: true
    });
  }
  if (discrete) {
    dispatchDiscreteCustomEvent(target, event);
  } else {
    target.dispatchEvent(event);
  }
}